<div id="home" class="home">

  <app-navbar class="home-navbar"></app-navbar>


  <mat-sidenav-container class="home-content" autosize>

    <mat-sidenav class="home-content__sidebar mat-elevation-z1"
                 [mode]="sideNavMode$ | async"
                 [opened]="sideNavOpenStatus$ | async"
                 (openedChange)="updateOpenedStatus($event)"
                 [disableClose]="(sideNavMode$ | async ) === 'side'">
      <app-sidebar [items]="menuItems | async"></app-sidebar>
    </mat-sidenav>

    <mat-sidenav-content class="home-content__container">
      <main [@routerTransition]="getState(main)">
        <router-outlet #main="outlet"></router-outlet>
      </main>
    </mat-sidenav-content>

  </mat-sidenav-container>


</div>
